import { TEAMS_ENTRY_FROM, TEAMS_PARSED_DATA } from "@/modules/queryData.types";
import {
    fetchDocumentLibForSite,
    fetchDriveItemResourceByItemId,
    fetchDriveItemResourceByItemPath,
    fetchDriveItemResourceByUserId,
    fetchSiteResourceBypath,
    getMSGraphTokenInit
} from "../apis/msGraph";
import { getTeamsDataFromUrl } from "../utils/utils";

export async function getFileInfoFromTeams() {
    await getMSGraphTokenInit(); // ensure get graphToken before any operation.
    const teamsData = getTeamsDataFromUrl();

    switch (teamsData.entryFrom) {
        case TEAMS_ENTRY_FROM.LEGACY:
            return getFileInfoLegacy(teamsData);

        case TEAMS_ENTRY_FROM.CHANNEL_TAB:
        case TEAMS_ENTRY_FROM.TASK_MODULE_FROM_MESSAGE_EXTENSION_CARD:
            return getFileInfoFromChannelTab(teamsData);

        case TEAMS_ENTRY_FROM.TASK_MODULE_FROM_CHANNEL:
            return getFileInfoFromTaskModuleChannel(teamsData);

        case TEAMS_ENTRY_FROM.TASK_MODULE_FROM_CHAT:
            return getFileInfoFromTaskModuleChat(teamsData);

        default:
            break;
    }
}

async function getFileInfoLegacy(teamsData: TEAMS_PARSED_DATA) {
    const { isChannel } = teamsData;
    if (isChannel) {
        return getFileInfoFromTaskModuleChannel(teamsData);
    }
    return getFileInfoFromTaskModuleChat(teamsData);
}

async function getFileInfoFromChannelTab(teamsData: TEAMS_PARSED_DATA) {
    const { driveId, fileId } = teamsData;
    const data = await fetchDriveItemResourceByItemId(driveId, fileId);
    return composeInfo(data);
}

export let teamsFileDataFromChannel;
async function getFileInfoFromTaskModuleChannel(teamsData: TEAMS_PARSED_DATA) {
    const { contentUrl } = teamsData;
    const { hostname, relativePath, filePath } = getPath(contentUrl);
    const { id: siteId } = await fetchSiteResourceBypath(hostname, relativePath);
    const { id: driveId } = await fetchDocumentLibForSite(siteId);
    const fileData = await fetchDriveItemResourceByItemPath(driveId, filePath);
    teamsFileDataFromChannel = {
        siteId,
        fileId: fileData.id
    };
    return composeInfo(fileData);
}

export let teamsFileDataFromChat;
async function getFileInfoFromTaskModuleChat(teamsData: TEAMS_PARSED_DATA) {
    const { contentUrl, chatUserId } = teamsData;
    const { filePath } = getPath(contentUrl);
    const fileData = await fetchDriveItemResourceByUserId(chatUserId!, filePath);
    teamsFileDataFromChat = {
        fileId: fileData.id
    };
    return composeInfo(fileData);
}

function composeInfo(data) {
    const {
        ['@microsoft.graph.downloadUrl']: fileDownloadUrl,
        id: fileId,
        lastModifiedDateTime,
        size,
        name: fileName
    } = data;
    return { fileName, fileDownloadUrl, fileId, size, lastModifiedDateTime };
}

function getPath(contentUrl: string) {
    const url = new URL(decodeURIComponent(contentUrl));
    const [_dash, sites, channelName, _shareDocDirName, ...filePathGroup] = url.pathname.split('/');
    return {
        hostname: url.hostname,
        relativePath: `${sites}/${channelName}`,
        filePath: filePathGroup.join('/'),
    };
}
